import { Step } from "../Steps/Step/Step";
import { StepState } from "../Models/StepState";
import { MarkedStep } from "../Models/MarkedStep";


// TODO: ta klasa jest chyba bez sensu
// POZA TYM Current TO TEN KTÓRY NIE JEST W STANIE Done ALBO Failed A TA KLASA TO PRZEKŁAMUJE
export class StepsMarker
{
    public static Mark(steps: Step<any>[]): MarkedStep[]
    {
        const marked: MarkedStep[] = [];

        let allowSetCurrent = true;

        let index = 1;
        for (const step of steps)
        {
            const wrapped = new MarkedStep(step);

            // wrapped.CurrentIndex = index;
            // wrapped.StepsCount = steps.length;

            if (wrapped.State == StepState.Failed)
            {
                marked.forEach(x => x.IsCurrent = false); // Remove current so far
                wrapped.IsCurrent = true;
                allowSetCurrent = false;
            }
            // else
            if (wrapped.IsUnDone && allowSetCurrent)
            {
                wrapped.IsCurrent = true;
                allowSetCurrent = false;
            }

            marked.push(wrapped);

            index++;
        }

        return marked;
    }
}
